// What the photo step shows, as pure functions of (new item?, pictures on file, shots, mode).

/** The one pill above the strip. Offline in bulk it says the uploads wait. */
export function photoPrompt({ isNewItem, shotCount, offline = false, onFileCount = 1 }) {
  if (offline) return "Keep going · they upload when you’re back online";
  // Nothing in the tray yet (a new item, or one on file with no pictures): "other" reads wrong.
  return shotCount === 0 && (isNewItem || onFileCount === 0) ? "Start with the front · fill the frame" : "Add other images";
}

/** The small tag on a picture already on file. */
export function savedTag(kind) {
  return kind === "packshot" ? "Pack shot" : kind === "shopify" ? "Shopify" : null;
}

/**
 * The strip, left to right. New item: a "Front" tile until the first shot, then the shots
 * (the first tagged Front) and a "+". Item on file: its pictures, a divider, this session's
 * shots (tagged New), and a "+".
 */
export function stripTiles({ isNewItem, onFile = [], shots = [] }) {
  const out = [];
  if (isNewItem) {
    if (!shots.length) return [{ key: "front", type: "front" }];
    shots.forEach((s, i) => out.push({ key: s.id, type: "shot", shot: s, index: i, tag: i === 0 ? "Front" : null }));
    out.push({ key: "plus", type: "plus" });
    return out;
  }
  // Numbered among the photos only: a pack shot is not "Saved photo 1".
  const photos = onFile.filter((img) => img.kind !== "packshot");
  onFile.forEach((img, i) => out.push({ key: "f" + (img.id || i), type: "saved", index: photos.indexOf(img), total: photos.length, image: img, tag: savedTag(img.kind) }));
  if (onFile.length) out.push({ key: "div", type: "divider" });
  shots.forEach((s, i) => out.push({ key: s.id, type: "shot", shot: s, index: i, tag: "New" }));
  out.push({ key: "plus", type: "plus" });
  return out;
}

/** The right-hand button's text. */
export function doneLabel({ quick, isNewItem, shotCount }) {
  if (!quick) return "Next ›";
  if (!shotCount) return "Done";
  return isNewItem ? `Done · ${shotCount}` : `Done · ${shotCount} new`;
}
